import { useTranslation } from 'react-i18next'
import { Row, StyledDetailValue } from './styled'
import OrderRefreshing from './OrderRefreshing'

const SlippageRow: React.FC<{
  // use bp as unit
  slippage: number
  loading: boolean
}> = ({ slippage, loading }) => {
  const { t } = useTranslation()

  return (
    <Row>
      <span>{t('slippage')}</span>
      <StyledDetailValue>
        <OrderRefreshing
          loading={loading}
          renderText={`${(slippage / 100).toFixed(1)}%`}
        />
      </StyledDetailValue>
    </Row>
  )
}

export default SlippageRow
